const SET_LIMITS = (state, limits) => {
  state.limits = limits;
};

// Whole-object replacement rather than Vue.set: `Vue.set` appears nowhere in this
// codebase, and Vue 2 cannot track a key added to an existing object (the same reason
// markSet replaces `edited` wholesale).
const SET_ACTIVE_CATALOGUE_KEY = (state, key) => {
  state.activeCatalogueKey = key;
};

const SET_CATALOGUE = (state, { key, catalogue }) => {
  state.catalogues = { ...state.catalogues, [key]: catalogue };
};

const SET_CATALOGUE_STATUS = (state, { key, status }) => {
  state.catalogueStatus = { ...state.catalogueStatus, [key]: status };
};

export default {
  SET_LIMITS,
  SET_ACTIVE_CATALOGUE_KEY,
  SET_CATALOGUE,
  SET_CATALOGUE_STATUS
};



// WEBPACK FOOTER //
// ./src/store/modules/aiLesson/mutations.js